import React, { Component } from 'react'
import Chart from 'chart.js'
import { Colors } from '../theme'
import PropTypes from 'prop-types'
import { formatCurrency } from '../util/CurrencyFormatter'

class DoughnutChart extends Component {
  constructor () {
    super()
    this.loadChart = this.loadChart.bind(this)
    this.unloadChart = this.unloadChart.bind(this)
    this.showChartValue = this.showChartValue.bind(this)
    this.state = {
      chartInfo: null,
      selectedSegment: {
        label: null
      }
    }
  }

  componentDidMount () {
    let chartData = [...this.props.chartValues]
    let chartLabels = [...this.props.chartLabels]
    let chartPadding = 10
    let chartLabelPadding = 25
    const winWidth = window.innerWidth
    if (winWidth <= 416) {
      chartPadding = 5
      chartLabelPadding = 5
    }

    if (winWidth <= 320) {
      chartPadding = 0
    }

    let options = {
      cutoutPercentage: 50,
      layout: {
        padding: chartPadding
      },
      legend: {
        labels: {
          padding: chartLabelPadding
        }
      },
      animation: {
        duration: 500
      }
    }
    let chartInfo = {
      type: 'doughnut',
      data: {
        labels: chartLabels,
        datasets: [{
          data: chartData,
          backgroundColor: [
            Colors.Chart.primaryColor,
            Colors.Chart.secondaryColor
          ]
        }]
      },
      options: options
    }

    this.setState({
      chartInfo
    })
  }

  loadChart (event) {
    // needs to call this for chart to render
    const ctx = document.getElementById(this.props.index).getContext('2d')
    const self = this
    let container = document.getElementById(`chartContainer${this.props.index}`)
    let spanContainer = container.childNodes
    let chartInfo = this.state.chartInfo
    setTimeout((event) => {
      spanContainer[1].classList.remove('hidden')
      self.mainChart = new Chart(ctx, chartInfo)
    }, 200)
  }

  unloadChart () {
    let container = document.getElementById(`chartContainer${this.props.index}`)
    let spanContainer = container.childNodes
    if (this.mainChart) {
      setTimeout(() => {
        this.mainChart.destroy({})
        spanContainer[1].classList.remove('hidden')
        spanContainer[1].classList.add('hidden')
      }, 500)
    }
  }

  showChartValue (event) {
    const segments = this.mainChart.getElementsAtEvent(event)
    const winWidth = window.innerWidth
    let defaultRadius = this.mainChart.outerRadius
    let addRadiusMargin = 10

    if (winWidth <= 416) {
      addRadiusMargin = 5
    }

    if (segments[0]) {
      const chartData = segments[0]['_chart'].chart.config.data.datasets[0].data
      const segmentIndex = segments[0]['_index']
      const segmentValue = Number(chartData[segmentIndex])
      const segmentLabel = segmentIndex === 0 ? 'Available' : 'Spent'

      this.mainChart.outerRadius = defaultRadius
      this.mainChart.update()
      segments[0]['_model'].outerRadius = defaultRadius + addRadiusMargin
      const selectedSegment = this.state.selectedSegment
      selectedSegment.value = segmentValue
      selectedSegment.label = segmentLabel

      this.setState({
        selectedSegment
      })
    } else {
      this.mainChart.outerRadius = defaultRadius
      this.mainChart.update()
    }
  }

  render () {
    let props = this.props
    let defaultVal = props.defaultChartValue
    let defaultLabel = props.defaultChartLabel
    let classes = props.className || ''
    let selectedClasses = `${props.selectedLabelClasses} selectedSegment` || 'selectedSegment'
    return (
      <div id={`chartContainer${props.index}`} className='chartContainer chartContainerDoughnut'>
        <canvas id={props.index} className={classes} alt={props.alt} width={props.width} height={props.height} onClick={this.showChartValue} />
        <div className={selectedClasses}>
          <span className='bold'>{this.state.selectedSegment.label ? this.state.selectedSegment.label : defaultLabel}</span>
          {this.state.selectedSegment.value ? formatCurrency(this.state.selectedSegment.value) : formatCurrency(defaultVal)}
        </div>
        {/* will only show in smallest devices */}
        <div className='txtCenter visible-xs hidden-sm hidden-md hidden-lg selectedSegmentResponsive'>
          <span className='bold'>{this.state.selectedSegment.label ? this.state.selectedSegment.label : defaultLabel}: </span>
          {this.state.selectedSegment.value ? (formatCurrency(this.state.selectedSegment.value)) : (formatCurrency(defaultVal))}
        </div>
      </div>
    )
  }
}

// Note about props to pass:
// alt, defaultChartLabel chartLabels to be localized before being passed
// chart colors are referenced in Theme, please add to theme file if more segments are required
// index must be unique if chart is being iterated
// className will be applied to charts canvas if passed
// selectedLabelClasses will be applied to container holding text in middle of canvas if passed

DoughnutChart.propTypes = {
  index: PropTypes.string.isRequired,
  defaultChartLabel: PropTypes.string.isRequired,
  defaultChartValue: PropTypes.number.isRequired,
  chartValues: PropTypes.array.isRequired,
  chartLabels: PropTypes.array.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  selectedLabelClasses: PropTypes.string
}

export default DoughnutChart



// WEBPACK FOOTER //
// ./src/controls/DoughnutChart.js